import React from 'react';

import {HyperLink} from '../index';
import {
    LeftArrow as BlueGreenLeft,
    RightArrow as BlueGreenRight,
    RightArrowLightGreen as FrogGreenRight,
    SilverRightArrow,
    SilverRightArrowMobi
} from '../../styles/icons';

export const colors = {
    blueGreen: 'blueGreen',
    frogGreen: 'frogGreen',
    silver: 'silver'
};

const ArrowHyperlink = ({
    label,
    url,
    target,
    wrapperClassName = '',
    color = colors.blueGreen,
    useRightArrow = true,
    onClick,
    labelClass = ''
}) => {
    const getArrowIcon = (className) => {
        if (!useRightArrow) {
            switch (color) {
                case colors.blueGreen:
                    return <BlueGreenLeft className={className} />;
                default:
                    return null;
            }
        } else {
            switch (color) {
                case colors.blueGreen:
                    return <BlueGreenRight className={className} />;
                case colors.frogGreen:
                    return <FrogGreenRight className={className} />;
                case colors.silver:
                    return (
                        <>
                            <div className='d-none d-lg-block'>
                                <SilverRightArrow className={className} />
                            </div>
                            <div className='d-lg-none d-block'>
                                <SilverRightArrowMobi className={className} />
                            </div>
                        </>
                    );
                default:
                    return null;
            }
        }
    };

    const getColorClass = () => {
        switch (color) {
            case colors.blueGreen:
                return 'blue-green-link';
            case colors.frogGreen:
                return 'frog-green-link';
            case colors.silver:
                return 'silver-link';
            default:
                return null;
        }
    };

    return (
        <HyperLink
            className={`arrow-hyperlink cursor-pointer ${wrapperClassName}`}
            url={url}
            target={target}
            clickEvent={onClick}
        >
            {!useRightArrow && getArrowIcon(`arrow-hyperlink-icon arrow-hyperlink-icon-left ${getColorClass()}`)}

            <span className={`arrow-hyperlink-label ${labelClass} ${getColorClass()}`}>{label}</span>

            {useRightArrow && getArrowIcon(`arrow-hyperlink-icon arrow-hyperlink-icon-right ${getColorClass()}`)}
        </HyperLink>
    );
};

export default ArrowHyperlink;
